import { get } from '@/api/base'

const notificationsApi = {
  getAll: async (companyUuid, params) => {
    const response = await get({
      path: 'notifications',
      params: { company_uuid: companyUuid, ...params },
    })
    return response.success
      ? {
          notifications: response.data.notifications,
          pagination: response.data.meta.pagination,
        }
      : response
  },
}

export default notificationsApi
